import {
  EVENT_BUY_BUTTON_CLICKED,
  EVENT_BUY_BUTTON_CLICKED_SUCCESS,
  EVENT_BUY_BUTTON_CLICKED_ERROR,
  EVENT_BUY_STEP,
  EVENT_BUY_STEP_SUCCESS,
  EVENT_BUY_STEP_ERROR,
  CRM_EVENT,
  CRM_EVENT_SUCCESS,
  CRM_EVENT_ERROR,
  CRM_EVENT_MAIL_IN_STORAGE_STARTED,
  CRM_EVENT_MAIL_IN_STORAGE_STARTED_SUCCESS,
  CRM_EVENT_MAIL_IN_STORAGE_STARTED_ERROR,
} from './crmEventActionConstants';

// crm event buy button clicked
export const postEventBuyButtonClicked = (payload) => ({
  type: EVENT_BUY_BUTTON_CLICKED,
  payload,
});

export const postEventBuyButtonClickedSuccess = (payload) => ({
  type: EVENT_BUY_BUTTON_CLICKED_SUCCESS,
  payload,
});

export const postEventBuyButtonClickedError = (payload) => ({
  type: EVENT_BUY_BUTTON_CLICKED_ERROR,
  payload,
});

// crm event buy flow step
export const postEventBuyStep = (payload) => ({
  type: EVENT_BUY_STEP,
  payload,
});

export const postEventBuyStepSuccess = (payload) => ({
  type: EVENT_BUY_STEP_SUCCESS,
  payload,
});

export const postEventBuyStepError = (payload) => ({
  type: EVENT_BUY_STEP_ERROR,
  payload,
});

// crm general events
export const postCrmEvent = (payload) => ({
  type: CRM_EVENT,
  payload,
});

export const postCrmEventSuccess = (payload) => ({
  type: CRM_EVENT_SUCCESS,
  payload,
});

export const postCrmEventError = (payload) => ({
  type: CRM_EVENT_ERROR,
  payload,
});

// crm event mail-in storage
export const postCrmEventMailinStorageStarted = (payload) => ({
  type: CRM_EVENT_MAIL_IN_STORAGE_STARTED,
  payload,
});

export const postCrmEventMailinStorageStartedSuccess = (payload) => ({
  type: CRM_EVENT_MAIL_IN_STORAGE_STARTED_SUCCESS,
  payload,
});

export const postCrmEventMailinStorageStartedError = (payload) => ({
  type: CRM_EVENT_MAIL_IN_STORAGE_STARTED_ERROR,
  payload,
});
